import React from 'react';

import { Typography, Box } from '@mui/material';

const Identificacao: React.FC = () => {
  return (
    <div className="identificacao-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Identificação
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de identificação em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Identificacao; 